"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTransitionGroup = require("react-transition-group");
var _classnames3 = _interopRequireDefault(require("classnames"));
var _reactDeviceDetect = require("react-device-detect");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Item = _interopRequireDefault(require("../../../Item"));
var _Offer = require("../../../Offer");
var _HorizontalLoader = _interopRequireDefault(require("../../../HorizontalLoader"));
var _Alert = _interopRequireWildcard(require("../../../../../ui/Alert"));
var _helpers = require("../../helpers");
var _Matrix = _interopRequireDefault(require("../Matrix"));
var _Filters = require("../Filters");
var _FiltersDropdown = require("../FiltersDropdown");
var _FiltersTriggerButton = require("../FiltersTriggerButton");
var _constants = require("./constants");
var _withProps = _interopRequireDefault(require("./withProps"));
var _styles = _interopRequireDefault(require("./styles"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var LefCol = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n background-color: ", ";\n"])), function (_ref) {
  var isStickyFilter = _ref.isStickyFilter,
    theme = _ref.theme;
  return isStickyFilter ? (0, _helpers.getPrimaryBackgroundColor)(theme) : undefined;
});
var StyledItem = (0, _styledComponents.default)(_Item.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &:before {\n    background-color: ", ";\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return _reactDeviceDetect.isDesktop ? (0, _helpers.getPrimaryBackgroundColor)(theme) : undefined;
});
var PricesMatrixDropdownBody = function PricesMatrixDropdownBody(_ref3) {
  var compact = _ref3.compact,
    country = _ref3.country,
    currency = _ref3.currency,
    doneSearch = _ref3.doneSearch,
    hotelID = _ref3.hotelID,
    hotelName = _ref3.hotelName,
    nightsRange = _ref3.nightsRange,
    offers = _ref3.offers,
    searching = _ref3.searching,
    queriesIDs = _ref3.queriesIDs;
  var rightColRef = (0, _react.useRef)(null);
  var leftColRef = (0, _react.useRef)(null);
  var stickyFilterPlaceholderRef = (0, _react.useRef)(null);
  var contentBlockRef = (0, _react.useRef)(null);
  var _useTranslation = (0, _reactI18next.useTranslation)('RESULT_CARD'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    activeOffer = _useState2[0],
    setActiveOffer = _useState2[1];
  var _useState3 = (0, _react.useState)((0, _helpers.createFilters)()),
    _useState4 = _slicedToArray(_useState3, 2),
    filters = _useState4[0],
    setFilters = _useState4[1];
  var _useState5 = (0, _react.useState)(_constants.FILTER_POSITION_STATES.STATIC),
    _useState6 = _slicedToArray(_useState5, 2),
    filterPosition = _useState6[0],
    setFilterPosition = _useState6[1];
  var isStickyFilter = R.equals(filterPosition, _constants.FILTER_POSITION_STATES.STICKY);
  var offersByActiveOffer = (0, _react.useMemo)(function () {
    return R.filter(function (offer) {
      var _offer$flights, _offer$flights2;
      return R.all(Boolean, [].concat(_toConsumableArray(activeOffer ? [offer.date === activeOffer.date, offer.nights === activeOffer.nights] : []), [(0, _helpers.getIsRoomFilterMatch)(offer, filters.rooms), (0, _helpers.getIsOperatorFilterMatch)(offer, filters.operators), (0, _helpers.getIsHourRangeFilterMatch)((_offer$flights = offer.flights) === null || _offer$flights === void 0 ? void 0 : _offer$flights.outbound, filters.outbound), (0, _helpers.getIsHourRangeFilterMatch)((_offer$flights2 = offer.flights) === null || _offer$flights2 === void 0 ? void 0 : _offer$flights2.inbound, filters.inbound)]));
    }, offers);
  }, [activeOffer, offers, filters]);
  var isEmptyResults = !searching && R.isEmpty(offers) && doneSearch;
  var isReadyResults = doneSearch && !R.isEmpty(offers);
  var onPriceClick = (0, _react.useCallback)(function (nextActiveOffer) {
    setActiveOffer(function (prevActiveOffer) {
      var node = rightColRef.current;
      if (node) {
        node.scrollTop = 0;
      }
      if (nextActiveOffer === prevActiveOffer) {
        return null;
      }
      return nextActiveOffer;
    });
  }, []);
  (0, _react.useEffect)(function () {
    var shouldActivateStickyMode = isReadyResults && _reactDeviceDetect.isMobileOnly && R.equals(filterPosition, _constants.FILTER_POSITION_STATES.STATIC);
    if (!shouldActivateStickyMode) {
      return;
    }
    var node = leftColRef.current;
    if (node) {
      var observer = new IntersectionObserver(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 1),
          entry = _ref5[0];
        if (entry.boundingClientRect.top <= 0) {
          setFilterPosition(_constants.FILTER_POSITION_STATES.STICKY);
        }
      }, {
        root: null,
        threshold: 1
      });
      observer.observe(node);
      return function () {
        observer.disconnect();
      };
    }
  }, [filterPosition, isReadyResults]);
  (0, _react.useEffect)(function () {
    var shouldActivateStaticMode = _reactDeviceDetect.isMobileOnly && R.equals(filterPosition, _constants.FILTER_POSITION_STATES.STICKY);
    if (!shouldActivateStaticMode) {
      return;
    }
    var node = stickyFilterPlaceholderRef.current;
    if (node) {
      var observer = new IntersectionObserver(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 1),
          entry = _ref7[0];
        if (entry.intersectionRatio === 1) {
          setFilterPosition(_constants.FILTER_POSITION_STATES.STATIC);
        }
      }, {
        root: null,
        threshold: 1
      });
      observer.observe(node);
      return function () {
        observer.disconnect();
      };
    }
  }, [filterPosition]);
  (0, _react.useEffect)(function () {
    if (!_reactDeviceDetect.isMobileOnly || !isReadyResults) {
      return;
    }
    var node = rightColRef.current;
    if (node) {
      var observer = new IntersectionObserver(function (_ref8) {
        var _ref9 = _slicedToArray(_ref8, 1),
          entry = _ref9[0];
        if (entry.isIntersecting) {
          setFilterPosition(function (position) {
            if (position === _constants.FILTER_POSITION_STATES.WAIT) {
              return _constants.FILTER_POSITION_STATES.STICKY;
            }
            return position;
          });
        } else {
          setFilterPosition(function (position) {
            if (position === _constants.FILTER_POSITION_STATES.STICKY) {
              return _constants.FILTER_POSITION_STATES.WAIT;
            }
            return position;
          });
        }
      }, {
        root: null,
        threshold: 0,
        rootMargin: "".concat(-100, "px 0px 0px 0px")
      });
      observer.observe(node);
      return function () {
        observer.disconnect();
      };
    }
  }, [isReadyResults]);
  var onSubmitMobileFilters = (0, _react.useCallback)(function (nextFilters) {
    setFilters(nextFilters);
    var node = contentBlockRef.current;
    if (node) {
      node.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, []);
  var onClosePricesAndDatesFilter = (0, _react.useCallback)(function () {
    if (activeOffer) {
      setActiveOffer(null);
    }
  }, [activeOffer]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultDropdown,
    ref: contentBlockRef
  }, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, {
    unmountOnExit: true,
    in: searching,
    timeout: 500
  }, function () {
    return /*#__PURE__*/_react.default.createElement(_HorizontalLoader.default, {
      queriesIDs: queriesIDs
    });
  }), isEmptyResults && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.emptyResults
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    type: _Alert.TYPES.ERROR
  }, t('PRICE_MATRIX_EMPTY_STATE'))), isStickyFilter && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default['sticky-filter-placeholder'],
    ref: stickyFilterPlaceholderRef
  }), /*#__PURE__*/_react.default.createElement(LefCol, {
    className: (0, _classnames3.default)(_styles.default.leftCol, _defineProperty({}, _styles.default['leftCol--sticky'], isStickyFilter)),
    isStickyFilter: isStickyFilter,
    ref: leftColRef
  }, isReadyResults && (_reactDeviceDetect.isMobileOnly ? /*#__PURE__*/_react.default.createElement(_FiltersDropdown.FiltersDropdown, {
    countryID: country.id,
    filters: filters,
    offers: offers,
    title: hotelName,
    onSubmit: onSubmitMobileFilters
  }, /*#__PURE__*/_react.default.createElement(_Matrix.default, {
    activeOfferID: R.prop('id', activeOffer),
    currency: currency,
    nightsRange: nightsRange,
    offers: offers,
    onPriceClick: onPriceClick
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FiltersTriggerButton.FiltersTriggerButton, {
    isActiveOffer: !!activeOffer,
    filters: filters
  }), /*#__PURE__*/_react.default.createElement(_Filters.FilterCollapsed, {
    disabled: true,
    initialOpen: true,
    arrow: false,
    className: _Filters.styles['filter--without-border-bottom-radius'],
    isActive: !!activeOffer,
    title: t('FILTER_PRICES_AND_DATES_TITLE'),
    onReset: onClosePricesAndDatesFilter
  }, /*#__PURE__*/_react.default.createElement(_Matrix.default, {
    activeOfferID: R.prop('id', activeOffer),
    currency: currency,
    nightsRange: nightsRange,
    offers: offers,
    onPriceClick: onPriceClick
  })), /*#__PURE__*/_react.default.createElement(_Filters.Filters, {
    countryID: country.id,
    offers: offers,
    filters: filters,
    onChangeFilters: setFilters
  })))), isReadyResults && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !_reactDeviceDetect.isMobileOnly && /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.resultToursColTitle
  }, t('PRICE_MATRIX_TITLE')), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames3.default)(_styles.default.rightCol, _constants.SCROLLABLE_BLOCK_CLASS_NAME),
    ref: rightColRef
  }, R.map(function (offer) {
    return /*#__PURE__*/_react.default.createElement(StyledItem, {
      className: (0, _classnames3.default)(_styles.default.resultsItem, _defineProperty({}, _styles.default.compact, compact)),
      compact: compact,
      key: offer.id,
      price: offer.price[currency.code]
    }, /*#__PURE__*/_react.default.createElement(_Offer.Offer, {
      buttons: /*#__PURE__*/_react.default.createElement(_Offer.Buttons, {
        compact: compact,
        hotelID: hotelID,
        isMobile: _reactDeviceDetect.isMobileOnly,
        offerID: offer.id,
        queryID: offer.queryID
      }),
      compact: compact,
      isMobile: _reactDeviceDetect.isMobileOnly
    }, /*#__PURE__*/_react.default.createElement(_Offer.Transports, {
      compact: compact,
      date: offer.date,
      flights: offer.flights,
      isMobile: _reactDeviceDetect.isMobileOnly,
      nights: offer.nights,
      nightsInHotel: offer.nightsInHotel,
      transport: offer.transport
    }), /*#__PURE__*/_react.default.createElement(_Offer.Food, {
      className: _styles.default.resultTourRoomName,
      compact: compact,
      food: offer.food,
      foodFullName: offer.foodFullName,
      informationOfCrossTour: offer.isCrossTour ? offer.informationOfCrossTour : undefined,
      isMobile: _reactDeviceDetect.isMobileOnly,
      room: offer.room.name,
      stopsale: offer.stopsale.hotel
    }), /*#__PURE__*/_react.default.createElement(_Offer.Price, {
      compact: compact,
      countryID: country.id,
      currency: currency,
      departure: offer.departure,
      hotelID: hotelID,
      includes: offer.includes,
      isHeightPromo: Boolean(offer.heightPromo),
      isMobile: _reactDeviceDetect.isMobileOnly,
      offerID: offer.id,
      operatorID: offer.operator,
      price: offer.price[currency.code],
      promoText: offer.promo || offer.heightPromo || undefined,
      queryID: offer.queryID
    })));
  }, offersByActiveOffer))));
};
PricesMatrixDropdownBody.propTypes = {
  country: _propTypes.default.shape({
    id: _propTypes.default.number.isRequired
  }).isRequired,
  currency: _propTypes.default.shape({
    code: _propTypes.default.string.isRequired
  }).isRequired,
  hotelID: _propTypes.default.number.isRequired,
  hotelName: _propTypes.default.string.isRequired,
  nightsRange: _propTypes.default.arrayOf(_propTypes.default.number).isRequired,
  offers: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  operatorsMap: _propTypes.default.object,
  queriesIDs: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  compact: _propTypes.default.bool,
  doneSearch: _propTypes.default.bool,
  searching: _propTypes.default.bool
};
var enhancer = R.compose(_withProps.default, _react.memo);
var _default = exports.default = enhancer(PricesMatrixDropdownBody);